import { useEffect } from "react";

type ModifierKeys = "ctrlKey" | "metaKey" | "shiftKey" | "altKey";

type OptionalKeys = {
  [key in ModifierKeys]?: boolean;
};

export default function useKeyboardShortcut(
  key: string,
  optionalKeys: OptionalKeys,
  callback: () => void,
  preventShortcutWhenModalIsOpen = true
) {
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (
        event.key === key &&
        event.ctrlKey === !!optionalKeys.ctrlKey &&
        event.metaKey === !!optionalKeys.metaKey &&
        event.shiftKey === !!optionalKeys.shiftKey &&
        event.altKey === !!optionalKeys.altKey
      ) {
        event.preventDefault();
        if (preventShortcutWhenModalIsOpen) {
          // check if a modal is present and if so, return early
          if (document.querySelector("[role=dialog]")) return;
          // click on the body to close any open dropdowns
          document.body.click();
        }

        callback();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [
    key,
    callback,
    optionalKeys.ctrlKey,
    optionalKeys.metaKey,
    optionalKeys.shiftKey,
    optionalKeys.altKey,
    preventShortcutWhenModalIsOpen
  ]);
}
